module.exports = __webpack_public_path__ + "static/media/st anthonys logo-1.49bb6302.png";